import PropTypes from "prop-types";

HorizontalCustomizeWrapper.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
};

export default function HorizontalCustomizeWrapper({ children, className = "" }) {
  return (
    <div className={`w-full mb-4 ml-0 xl:ml-2 xl:-mt-4 lg:max-w-screen-lg ${className}`}>
      {children}
    </div>
  );
}
